import { mockMunicipalEntity } from '@prodcard/core'
import { uniqBy, times } from 'lodash'

import { RemoteMunicipalEntitiesService } from '@prodcard/core-web-app'
import { httpClient } from './remote'

const municipalEntities = uniqBy(
  times(70, () => mockMunicipalEntity()),
  'name',
)

const municipalEntitiesService = new RemoteMunicipalEntitiesService(httpClient)

export { municipalEntities, municipalEntitiesService }
